<template>
    <div>
        <div :class="inputContainerClass">
            <b-form-group :state="state">
                <template slot="label">
                    <div
                        class="d-flex justify-content-between align-items-center text-muted font-weight-bold"
                    >
                        <span>
                            {{ $t(axisTranslationPath) }}
                        </span>
                        <i :class="`fas ${arrow}`" />
                    </div>
                </template>
                <b-form-input
                    no-wheel
                    size="sm"
                    type="number"
                    :value="value"
                    :state="state"
                    @input="$emit('change', $event)"
                />
            </b-form-group>
        </div>
        <b-form-invalid-feedback :state="state">
            <div v-if="!validation.required">
                {{ $t('form.validations.required') }}
            </div>
            <div v-if="!validation.minValue">
                {{ $t('form.validations.minValue', { value: limits.min }) }}
            </div>
            <div v-if="!validation.maxValue">
                {{ $t('form.validations.maxValue', { value: limits.max }) }}
            </div>
            <div v-if="!validation.decimal">
                {{ $t('form.validations.numeric') }}
            </div>
        </b-form-invalid-feedback>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        limits: {
            type: Object,
            required: true,
        },
        axis: {
            type: String,
            required: true,
        },
        validation: {
            type: Object,
            required: true,
        },
    },
    computed: {
        inputContainerClass() {
            let base = 'border-left'
            return this.state !== false ? base : base + ' invalid'
        },
        state() {
            return this.validation.state
        },
        axisTranslationPath() {
            return `nBox.${this.axis}Axis`
        },
        arrow() {
            return this.axis == 'x' ? 'fa-arrow-right' : 'fa-arrow-up'
        },
    },
}
</script>
